const termsOfService = {
  title: "Όροι Χρήσης",
  sections: [
    {
      heading: "1. Αποδοχή των όρων",
      paragraphs: [
        'Με την πρόσβαση και τη χρήση των υπηρεσιών της Elite Dental Solutions ("εμείς", "μας" ή "εμάς"), συμφωνείτε ότι δεσμεύεστε από τους παρόντες Όρους Χρήσης. Εάν δεν συμφωνείτε με αυτούς τους όρους, παρακαλούμε μην χρησιμοποιείτε τις υπηρεσίες μας.',
      ],
    },
    {
      heading: "2. Περιγραφή υπηρεσιών",
      paragraphs: [
        "Παρέχουμε οδοντιατρικές και στοματικής υγείας υπηρεσίες, συμπεριλαμβανομένων ενδεικτικά των εξής:",
      ],
      bullets: [
        "Οδοντιατρικές εξετάσεις και συμβουλευτική",
        "Προληπτική οδοντιατρική φροντίδα",
        "Αποκαταστατικές θεραπείες",
        "Αισθητικές οδοντιατρικές διαδικασίες",
        "Στοματική χειρουργική",
        "Επείγουσα οδοντιατρική φροντίδα",
      ],
    },
    {
      heading: "3. Ραντεβού και ακυρώσεις",
      paragraphs: [
        "Απαιτείται ειδοποίηση τουλάχιστον 24 ωρών για ακύρωση ραντεβού. Καθυστερημένες ακυρώσεις ή μη προσέλευση ενδέχεται να επιβαρύνονται με χρέωση. Διατηρούμε το δικαίωμα να ζητήσουμε προκαταβολή για ορισμένες διαδικασίες ή θεραπείες.",
      ],
    },
    {
      heading: "4. Όροι πληρωμής",
      paragraphs: [
        "Η πληρωμή απαιτείται κατά την παροχή της υπηρεσίας, εκτός εάν έχει συμφωνηθεί διαφορετικά. Δεχόμαστε διάφορους τρόπους πληρωμής, συμπεριλαμβανομένων μετρητών, καρτών και εγκεκριμένων προγραμμάτων πληρωμής. Τυχόν αξιώσεις προς ασφαλιστικούς φορείς αποτελούν ευθύνη του ασθενούς.",
      ],
    },
    {
      heading: "5. Ιατρικές πληροφορίες",
      paragraphs: [
        "Συμφωνείτε να παρέχετε ακριβείς και πλήρεις πληροφορίες ιατρικού ιστορικού. Η μη γνωστοποίηση σχετικών ιατρικών πληροφοριών μπορεί να επηρεάσει τα αποτελέσματα της θεραπείας και να θέσει σε κίνδυνο την υγεία σας.",
      ],
    },
    {
      heading: "6. Αποφάσεις θεραπείας",
      paragraphs: [
        "Παρότι παρέχουμε επαγγελματικές συστάσεις, έχετε το δικαίωμα να λαμβάνετε ενημερωμένες αποφάσεις σχετικά με τη θεραπεία σας. Θα σας εξηγήσουμε τις διαθέσιμες επιλογές, τους κινδύνους και τα οφέλη, ώστε να σας βοηθήσουμε να αποφασίσετε.",
      ],
    },
    {
      heading: "7. Χρήση ιστοσελίδας",
      paragraphs: [
        "Η ιστοσελίδα μας παρέχεται αποκλειστικά για ενημερωτικούς σκοπούς. Παρότι καταβάλλουμε προσπάθεια για την ακρίβεια των πληροφοριών, αυτές δεν πρέπει να θεωρούνται ιατρική συμβουλή. Για εξατομικευμένη καθοδήγηση, συμβουλευτείτε πάντοτε οδοντίατρο.",
      ],
    },
    {
      heading: "8. Περιορισμός ευθύνης",
      paragraphs: [
        "Στοχεύουμε στην παροχή οδοντιατρικής φροντίδας υψηλής ποιότητας, ωστόσο δεν μπορούμε να εγγυηθούμε συγκεκριμένα αποτελέσματα. Δεν φέρουμε ευθύνη για έμμεσες, επακόλουθες ή τυχαίες ζημίες που σχετίζονται με τις υπηρεσίες μας, στο μέτρο που επιτρέπεται από τον νόμο.",
      ],
    },
    {
      heading: "9. Αλλαγές στους όρους",
      paragraphs: [
        "Διατηρούμε το δικαίωμα να τροποποιούμε τους παρόντες όρους οποτεδήποτε. Οι αλλαγές τίθενται σε ισχύ αμέσως μετά τη δημοσίευσή τους στην ιστοσελίδα μας. Η συνεχιζόμενη χρήση των υπηρεσιών μας συνιστά αποδοχή των τροποποιημένων όρων.",
        "Τελευταία ενημέρωση:",
      ],
      lastUpdatedLocale: "el-GR",
    },
  ],
};

export default termsOfService;

